export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5909.714dc830.jpg";